import dynamic from "next/dynamic";

import type { BriefingReportPageData } from "content-ui/briefings/fetchers/briefingReportFetcher";
import Heading from "content-ui/briefings/components/briefingsReports/elements/heading";
import CardContainer from "content-ui/briefings/components/briefingsReports/elements/cardContainer";
import { getAirtablePropsFromIframe } from "content-ui/briefings/lib";

const AirtableChart = dynamic(() => import("./airtableChart/airtableChart"), {
  ssr: false,
});

const DealsCard = ({
  briefing,
  id,
}: {
  briefing: BriefingReportPageData;
  id: string;
}) => {
  const airtableChartProps = getAirtablePropsFromIframe(
    briefing.airtableEmbedCode
  );
  if (
    !briefing.airtableEmbedCode ||
    !briefing.dealsHeading ||
    !airtableChartProps.src
  )
    return null;

  return (
    <CardContainer
      id={`content__${id}`}
      innerClassNames={"grid md:gap-[16px] gap-[0px]"}
    >
      <Heading text={briefing.dealsHeading} id={id} />
      <div>
        <AirtableChart
          title={`Deals table`}
          width={airtableChartProps.width}
          height={airtableChartProps.height}
          src={airtableChartProps.src}
        />
      </div>
    </CardContainer>
  );
};

export default DealsCard;
